import { AppState} from './types';

export function showPhoneControl(state: AppState) {
  return state.showPhoneControl;
}